
export const UD_X_CLIENT = 'VVNELTk0MTI0MTA0LWZjZWYtNDE0Yi05ZDc3LWYwYTE5MThmYTY4MzomcWJxeEx2ZVdSeUBDd2dkbVc1VGN6JGpHYmpuTEV3Mw=='; // used in header
export const UD_X_CLIENT_URL = 'VVNELTk0MTI0MTA0LWZjZWYtNDE0Yi05ZDc3LWYwYTE5MThmYTY4MzomcWJxeEx2ZVdSeUBDd2dkbVc1VGN6JGpHYmpuTEV3Mw'; // used with redirect url